import { unwrapEnvelope } from "../../../utils/api/unwrap-envelope.ts"
import type { WidgetInstanceV4 } from "../../DashboardPage/redux/widgets.types"
import type {
  DashboardTemplate,
  DashboardTemplatePayload,
  TemplateScope
} from "../types"

export interface TemplateFormValues {
  scope: TemplateScope
  role: number | null
  key: string
  name: string
  widgets: WidgetInstanceV4[]
  isDefault: boolean
}

const toV4Widget = (w: WidgetInstanceV4): WidgetInstanceV4 => ({
  id: w.id,
  slug: w.slug,
  type: w.type,
  dataSource: w.dataSource,
  config: w.config ?? {}
})

export const buildTemplatePayload = (
  values: TemplateFormValues
): DashboardTemplatePayload => {
  const key = values.key.trim()
  return {
    scope: values.scope,
    role: values.scope === "role" ? values.role : null,
    key,
    layout: {
      key,
      name: values.name.trim(),
      widgets: values.widgets.map(toV4Widget),
      hidden: []
    },
    is_default: values.isDefault
  }
}

export { unwrapEnvelope }

export const asTemplateList = (data: unknown): DashboardTemplate[] => {
  const unwrapped = unwrapEnvelope<unknown>(data)
  if (Array.isArray(unwrapped)) return unwrapped as DashboardTemplate[]
  const results = (unwrapped as { results?: unknown })?.results
  return Array.isArray(results) ? (results as DashboardTemplate[]) : []
}
